module.exports = __webpack_public_path__ + "img/bg 01 white.9b9163cf.png";